import Tippy from '@tippyjs/react'

import { cn } from '@/app/utils'
import { PageType } from '@/components/entities/requests/model/types'

type Props = {
  pageType: PageType
  unreadCount: number
  className?: string
}

export const CommentsCounter = ({
  pageType,
  unreadCount,
  className
}: Props) => (
  <Tippy
    content={
      <div className="pointer h-[72px] w-[194px] rounded-12 bg-white p-12 font-pro text-grey-100 shadow-[0px_5px_30px_0px_rgba(0,0,0,0.15)]  text-16">
        Новые комментарии в чате по{' '}
        {pageType === PageType.Passes ? 'пропуску' : 'обращению'}
      </div>
    }
    arrow={false}
    trigger="mouseenter"
    placement="bottom-start"
    className="absolute"
  >
    <span
      data-testid="request-chat-unread-counter-id"
      className={cn(
        'cursor-pointer rounded-100 bg-black px-8 py-2 font-bold !text-white text-12',
        className
      )}
    >
      {unreadCount || 0}
    </span>
  </Tippy>
)
